import React from "react"
import NavLink from "./navLink"

const HeroBanner = ({ blok }) => {
	const {
		heading,
		subheading,
		subheadingImage,
		subheading_image, // Try snake_case variant
		image,
		textColor = "#25425b", // Default to Blue
		link,
	} = blok || {}

	const textColorStyle = {
		color: textColor,
	}

	// Get image URL - handle different possible image structures
	const imageUrl =
		image?.filename || image?.url || (typeof image === "string" ? image : null)

	// Enhanced subheading image URL extraction - handle Storyblok asset structure
	// Try both camelCase and snake_case field names
	const subheadingImageData = subheadingImage || subheading_image

	let subheadingImageUrl = null
	if (subheadingImageData) {
		console.log("Subheading image object:", subheadingImageData)
		if (typeof subheadingImageData === "string") {
			subheadingImageUrl = subheadingImageData
		} else if (subheadingImageData.filename) {
			subheadingImageUrl = subheadingImageData.filename
		} else if (subheadingImageData.url) {
			subheadingImageUrl = subheadingImageData.url
		} else if (subheadingImageData.content) {
			// Handle nested content structure
			subheadingImageUrl =
				subheadingImageData.content?.filename ||
				subheadingImageData.content?.url
		}

		// Debug logging
		if (!subheadingImageUrl) {
			console.log(
				"Subheading image object (URL not found):",
				subheadingImageData
			)
		} else {
			console.log("Subheading image URL extracted:", subheadingImageUrl)
		}
	} else {
		console.log("No subheading image data found")
	}

	// Build content wrapper - wrap in link if link is provided
	const ContentWrapper = ({ children }) => {
		if (link && link.linktype) {
			return (
				<NavLink link={link} className="block no-underline">
					{children}
				</NavLink>
			)
		}
		return <>{children}</>
	}

	return (
		<div className="w-full bg-white">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 lg:py-20">
				<ContentWrapper>
					<div className="flex flex-col lg:flex-row items-center justify-center gap-8 lg:gap-12">
						{/* Text Content */}
						<div className="flex-1 text-center lg:text-left">
							{heading && (
								<h1
									className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6"
									style={textColorStyle}
								>
									{heading}
								</h1>
							)}
							{subheading && (
								<p
									className="text-base sm:text-lg md:text-xl lg:text-2xl font-light"
									style={textColorStyle}
								>
									{subheading}
								</p>
							)}
							{/* Subheading Image - only render when a valid URL exists */}
							{subheadingImageUrl && (
								<div
									className="mt-4 md:mt-6 w-full max-w-md mx-auto lg:mx-0 flex-shrink-0"
									style={{ minHeight: "50px" }}
								>
									<img
										className="w-full h-auto object-contain rounded-lg block"
										src={subheadingImageUrl}
										alt={
											subheadingImage?.alt || subheading || "Subheading image"
										}
										style={{
											display: "block",
											maxHeight: "400px",
											width: "100%",
										}}
										onError={e => {
											console.error(
												"Failed to load subheading image:",
												subheadingImageUrl,
												subheadingImage
											)
											e.target.style.display = "none"
										}}
										onLoad={() => {
											console.log(
												"Subheading image loaded successfully:",
												subheadingImageUrl
											)
										}}
									/>
								</div>
							)}
						</div>

						{/* Image */}
						{imageUrl && (
							<div className="flex-1 w-full lg:w-auto">
								<img
									className="w-full h-auto object-cover rounded-lg"
									src={imageUrl}
									alt={image?.alt || heading || "Hero banner image"}
									onError={e => {
										console.error("Failed to load hero banner image:", imageUrl)
										e.target.style.display = "none"
									}}
								/>
							</div>
						)}
					</div>
				</ContentWrapper>
			</div>
		</div>
	)
}

export default HeroBanner
